import { z } from 'zod';

export const symbolSchema = z.object({
  id: z.number(),
  symbol: z.string(),
  name: z.string(),
  sector: z.string(),
});

export type SymbolSchema = z.infer<typeof symbolSchema>;

export const symbolFormSchema = z.object({
  symbol: z.string().min(2, {
    error: 'Symbol must be at least 2 characters.',
  }),
});

export type SymbolFormSchema = z.infer<typeof symbolFormSchema>;
